var map = {
	"./1.svg": "a881",
	"./2.svg": "743f",
	"./3.svg": "41a7",
	"./4.svg": "8280",
	"./5.svg": "9566",
	"./6.svg": "a307",
	"./7.svg": "a1e9",
	"./8.svg": "6c20",
	"./9.svg": "1e91"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";